
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#1CD8AA","fill-rule":"evenodd","d":"M12.75 17.216v3.034a.75.75 0 11-1.5 0v-3.034A8.25 8.25 0 013.75 9V7.5a.75.75 0 01.75-.75h3v-3a.75.75 0 011.5 0v3h6v-3a.75.75 0 111.5 0v3h3a.75.75 0 01.75.75V9a8.25 8.25 0 01-7.5 8.216zM5.25 8.25V9a6.75 6.75 0 1013.5 0v-.75H5.25z"}})])
          )
        }
      }
    